import { DatePicker, DatePickerProps } from 'antd';
import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

const DatePickerWrapper = styled.div`
  width: 188px;
  display: block;
  .date-picker {
    width: 100%;
  }
  .has-bottom-margin {
    margin-bottom: 8px;
  }
`;

export interface IDatePickerFilterStyleProps extends DatePickerProps {
  marginBottom?: boolean;
}

/**
 * Wrapper per il DatePicker nei filtri di tabella.
 */
export function DatePickerFilterStyle(props: IDatePickerFilterStyleProps) {
  const { marginBottom, ...rest } = props;

  return (
    <DatePickerWrapper>
      <DatePicker
        className={clx('date-picker', { 'has-bottom-margin': marginBottom })}
        {...rest}
      />
    </DatePickerWrapper>
  );
}
